// Portal-configured teaser: a short message above the idle widget that invites
// visitors to start a conversation. Visitors can close it for the session.
export const TEASER_MAX_LENGTH = 80;
/**
 * Fail-closed: only an enabled teaser whose trimmed text is 1 to 80
 * characters comes back; disabled, absent and malformed all yield null.
 * Characters are counted as code points, like the service's len().
 */
export function normalizeTeaser(raw) {
    if (typeof raw !== "object" || raw === null)
        return null;
    const t = raw;
    if (t.enabled !== true || typeof t.text !== "string")
        return null;
    const text = t.text.trim();
    const length = [...text].length;
    if (length === 0 || length > TEASER_MAX_LENGTH)
        return null;
    return { enabled: true, text };
}
// Geist Mono, as on the moss.dev launch pill. Registered under its own family
// name so it never collides with a host page's fonts; falls back to the
// system monospace when blocked (e.g. a CSP without font-src for jsDelivr).
const TEASER_FONT_NAME = "Moss Geist Mono";
const TEASER_FONT_URL = "https://cdn.jsdelivr.net/npm/geist@1.7.2/dist/fonts/geist-mono/GeistMono-Regular.woff2";
export const TEASER_FONT_FAMILY = `"${TEASER_FONT_NAME}", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`;
/** Registers the teaser font with the document once (FontFace API, no markup). */
export function loadTeaserFont() {
    if (typeof FontFace === "undefined" || typeof document === "undefined" || !document.fonts)
        return;
    for (const face of document.fonts) {
        if (face.family.replace(/["']/g, "") === TEASER_FONT_NAME)
            return;
    }
    const face = new FontFace(TEASER_FONT_NAME, `url("${TEASER_FONT_URL}") format("woff2")`, {
        weight: "400",
        display: "swap",
    });
    document.fonts.add(face);
    face.load().catch(() => { });
}
const dismissedKey = (publishableKey) => `moss-fa-teaser-dismissed:${publishableKey}`;
/** True once the visitor closed the teaser or started talking this session. */
export function isTeaserDismissed(publishableKey) {
    try {
        return globalThis.sessionStorage?.getItem(dismissedKey(publishableKey)) === "1";
    }
    catch {
        return false;
    }
}
/** Hides the teaser for the rest of the browser session. */
export function dismissTeaser(publishableKey) {
    try {
        globalThis.sessionStorage?.setItem(dismissedKey(publishableKey), "1");
    }
    catch {
        // Storage blocked: the caller still hides it for this page.
    }
}
